import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import "./TermsOfService.css";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import Logo from "../img/logo.png";
import { useNavigate, useLocation } from "react-router-dom";

function TermsOfService() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { user, logout } = useAuth();

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleLogout = () => {
    logout();
  };

   const navigate = useNavigate();
  const location = useLocation();

  const handleClick = (e) => {
    e.preventDefault();
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        document.getElementById("features")?.scrollIntoView({ behavior: "smooth" });
      }, 100); // small delay for page to render
    } else {
      document.getElementById("features")?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <Helmet>
        <title>Terms of Service - Revexia</title>
        <meta
          name="description"
          content="Revexia Terms of Service - Read our terms governing your access to and use of the Revexia platform and services."
        />
      </Helmet>

      <div className="homepage">
        {/* Navigation - Same as HomePage */}
         <nav className="navbar-custom">
          <div className="navbar-container">
            {/* Logo Section */}
            <div className="navbar-brand-custom">
              <Link to="/">
                <img src={Logo} alt="Revexia Logo" className="navbar-logo-img" />
              </Link>
            </div>

            {/* Center Navigation Pills */}
            <div className="navbar-center-pill">
              <ul className="nav-menu-pills">
                <li className="nav-item-pill">
                  <Link to="/" className="nav-link-pill">
                    Home
                  </Link>
                </li>
                <li className="nav-item-pill">
                   <a href="/#features" className="nav-link-pill" onClick={handleClick}>
                    Feature
                  </a>
                </li>

                <li className="nav-item-pill nav-item-dropdown">
                  <button className="nav-link-pill nav-dropdown-toggle">
                    Resources
                    <svg
                      width="10"
                      height="6"
                      viewBox="0 0 10 6"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="dropdown-arrow"
                    >
                      <path
                        d="M1 1L5 5L9 1"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                  <div className="nav-dropdown-menu">
                    <Link to="/how" className="nav-dropdown-item">
                      How it works
                    </Link>
                    <Link to="/support" className="nav-dropdown-item">
                      Support overview
                    </Link>
                    <Link to="/trust" className="nav-dropdown-item">
                      Trust Center
                    </Link>
                    <Link to="/privacy-policy" className="nav-dropdown-item">
                      Privacy Policy
                    </Link>
                    <Link to="/terms" className="nav-dropdown-item">
                      Terms of Service
                    </Link>
                     <Link to="/facebook-terms" className="nav-dropdown-item">
                                          Facebook Terms
                                        </Link>
                  </div>
                </li>
                <li className="nav-item-pill">
                  <Link to="/blog" className="nav-link-pill">
                    Blog
                  </Link>
                </li>
                
              </ul>
            </div>

            {/* Right Side - Auth Buttons */}
            <div className="navbar-auth-section">
              {user ? (
                <>
                  <Link to="/dashboard" className="btn-nav-outline">
                    Dashboard
                  </Link>
                  <button onClick={handleLogout} className="btn-nav-gradient">
                    Logout
                  </button>
                </>
              ) : (
                <>
                  <Link to="/join-waitlist" className="btn-nav-gradient">
                                     Get Started
                                   </Link>
                                     <Link to="/auth" className="btn-nav-gradientlogin">
                                     Login
                                   </Link>
                </>
              )}
            </div>

            {/* Mobile Toggle */}
            <button
              className="navbar-mobile-toggle"
              type="button"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              <span className="navbar-toggler-icon-custom"></span>
            </button>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="navbar-mobile-menu">
              <ul className="mobile-nav-list">
                <li>
                  <Link to="/" onClick={() => setMobileMenuOpen(false)}>
                    Home
                  </Link>
                </li>

                <li >
                  <a href="/#features" onClick={(e) => {
                      setMobileMenuOpen(false);
                      handleClick(e);
                    }} >
                    Feature
                  </a>
                </li>
                
                <li>
                  <Link to="/how" onClick={() => setMobileMenuOpen(false)}>
                    How it works
                  </Link>
                </li>
                <li>
                  <Link to="/support" onClick={() => setMobileMenuOpen(false)}>
                    Support overview
                  </Link>
                </li>
                <li>
                  <Link to="/trust" onClick={() => setMobileMenuOpen(false)}>
                    Trust Center
                  </Link>
                </li>
                <li>
                  <Link to="/blog" onClick={() => setMobileMenuOpen(false)}>
                    Blog
                  </Link>
                </li>
                
              </ul>
              <div className="mobile-auth-buttons">
                {user ? (
                  <>
                    <Link
                      to="/dashboard"
                      className="btn-nav-outline"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      Dashboard
                    </Link>
                    <button
                      onClick={() => {
                        handleLogout();
                        setMobileMenuOpen(false);
                      }}
                      className="btn-nav-gradient"
                    >
                      Logout
                    </button>
                  </>
                ) : (
                  <>
                    <Link
                      to="/auth"
                      className="btn-nav-gradient"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      Login
                    </Link>
                  </>
                )}
              </div>
            </div>
          )}
        </nav>

        {/* Terms of Service Content */}
        <div className="terms-content-wrapper">
          {/* Header Section */}
          <div className="terms-header-section">
            <div className="terms-container">
              <h1 className="terms-main-title">Terms of Service</h1>
              <p className="terms-last-updated">Last updated: 28.01.2026</p>
              <p className="terms-intro-text">
                These Terms of Service ("Terms") govern your access to and use of the Revexia website 
                and platform (the "Service"), operated by Revexia.
              </p>
              <p className="terms-intro-text terms-highlight">
                By accessing or using the Service, you agree to these Terms.
              </p>
            </div>
          </div>

          {/* Content Section */}
          <div className="terms-content-section">
            <div className="terms-container">
              {/* Section 1 */}
              <div className="terms-section">
                <h2 className="terms-section-title">1. The Service</h2>
                <p className="terms-paragraph">
                  Revexia is a software-as-a-service platform that analyzes customer interactions and 
                  activity across connected platforms to help users understand customer behavior and 
                  purchase intent.
                </p>
                <p className="terms-paragraph terms-highlight">
                  Revexia provides analytics and intelligence, not guaranteed business outcomes.
                </p>
              </div>

              {/* Section 2 */}
              <div className="terms-section">
                <h2 className="terms-section-title">2. Eligibility</h2>
                <p className="terms-paragraph">You must:</p>
                <ul className="terms-list">
                  <li>Be at least 18 years old</li>
                  <li>Have authority to act on behalf of your business (if applicable)</li>
                  <li>Use the Service in compliance with all applicable laws and third-party platform rules</li>
                </ul>
              </div>

              {/* Section 3 */}
              <div className="terms-section">
                <h2 className="terms-section-title">3. Account Registration</h2>
                <p className="terms-paragraph">
                  To use Revexia, you must create an account and provide accurate, up-to-date information.
                </p>
                <p className="terms-paragraph">You are responsible for:</p>
                <ul className="terms-list">
                  <li>Maintaining the security of your account</li>
                  <li>All activity that occurs under your account</li>
                  <li>Ensuring that any connected platforms are authorized by you</li>
                </ul>
              </div>

              {/* Section 4 */}
              <div className="terms-section">
                <h2 className="terms-section-title">4. Integrations & Third-Party Services</h2>
                <p className="terms-paragraph">
                  Revexia may integrate with third-party services such as social media platforms, 
                  DM tools, and ecommerce platforms.
                </p>
                <p className="terms-paragraph">You acknowledge that:</p>
                <ul className="terms-list">
                  <li>Your use of third-party services is governed by their own terms</li>
                  <li>Revexia operates only with permissions you grant</li>
                  <li>Revexia does not control third-party platforms or guarantee their availability</li>
                </ul>
              </div>

              {/* Section 5 */}
              <div className="terms-section">
                <h2 className="terms-section-title">5. Data Use & Privacy</h2>
                <p className="terms-paragraph">
                  Your use of the Service is subject to our{" "}
                  <Link to="/privacy-policy" className="terms-inline-link">Privacy Policy</Link>, 
                  which explains how we collect and process data.
                </p>
                <p className="terms-paragraph">Revexia:</p>
                <ul className="terms-list">
                  <li>Processes data only as authorized by you</li>
                  <li>Does not send unsolicited messages on your behalf</li>
                  <li>Does not sell personal data</li>
                </ul>
                <p className="terms-paragraph terms-highlight">
                  You are responsible for ensuring you have the legal right to use and process any 
                  data you connect to Revexia.
                </p>
              </div>

              {/* Section 6 */}
              <div className="terms-section">
                <h2 className="terms-section-title">6. Acceptable Use</h2>
                <p className="terms-paragraph">You agree not to:</p>
                <ul className="terms-list">
                  <li>Use the Service for unlawful or deceptive purposes</li>
                  <li>Violate platform rules (e.g. Meta, Shopify)</li>
                  <li>Attempt to bypass security or access controls</li>
                  <li>Use Revexia to spam, harass, or misuse customer data</li>
                </ul>
                <p className="terms-paragraph terms-highlight">
                  We reserve the right to suspend or terminate accounts that violate these Terms.
                </p>
              </div>

              {/* Section 7 */}
              <div className="terms-section">
                <h2 className="terms-section-title">7. Fees & Subscriptions</h2>
                <p className="terms-paragraph">
                  Some features of Revexia may require payment.
                </p>
                <p className="terms-paragraph">Unless otherwise stated:</p>
                <ul className="terms-list">
                  <li>Fees are billed on a subscription basis</li>
                  <li>Fees are non-refundable except where required by law</li>
                  <li>Taxes may apply depending on your location</li>
                </ul>
                <p className="terms-paragraph">
                  Full pricing details will be provided at the time of purchase.
                </p>
              </div>

              {/* Section 8 */}
              <div className="terms-section">
                <h2 className="terms-section-title">8. Intellectual Property</h2>
                <p className="terms-paragraph">
                  All content, software, and technology used in the Service are owned by Revexia 
                  or its licensors.
                </p>
                <p className="terms-paragraph">
                  You are granted a limited, non-exclusive, non-transferable right to use the Service 
                  in accordance with these Terms.
                </p>
                <p className="terms-paragraph">
                  You may not copy, modify, reverse engineer, or redistribute the Service without permission.
                </p>
              </div>

              {/* Section 9 */}
              <div className="terms-section">
                <h2 className="terms-section-title">9. No Guarantee of Results</h2>
                <p className="terms-paragraph">
                  Revexia provides insights and recommendations, but does not guarantee:
                </p>
                <ul className="terms-list">
                  <li>Revenue increases</li>
                  <li>Conversion rates</li>
                  <li>Business performance outcomes</li>
                </ul>
                <p className="terms-paragraph terms-highlight">
                  Business decisions and outcomes remain your responsibility.
                </p>
              </div>

              {/* Section 10 */}
              <div className="terms-section">
                <h2 className="terms-section-title">10. Limitation of Liability</h2>
                <p className="terms-paragraph">To the maximum extent permitted by law:</p>
                <ul className="terms-list">
                  <li>Revexia is provided "as is"</li>
                  <li>We are not liable for indirect, incidental, or consequential damages</li>
                  <li>Our total liability shall not exceed the amount you paid for the Service in the preceding 12 months</li>
                </ul>
              </div>

              {/* Section 11 */}
              <div className="terms-section">
                <h2 className="terms-section-title">11. Termination</h2>
                <p className="terms-paragraph">You may stop using the Service at any time.</p>
                <p className="terms-paragraph">We may suspend or terminate access if:</p>
                <ul className="terms-list">
                  <li>You violate these Terms</li>
                  <li>Required by law</li>
                  <li>Necessary to protect the Service or other users</li>
                </ul>
              </div>

              {/* Section 12 */}
              <div className="terms-section">
                <h2 className="terms-section-title">12. Changes to the Service or Terms</h2>
                <p className="terms-paragraph">
                  We may update these Terms or modify the Service from time to time.
                </p>
                <p className="terms-paragraph">
                  Material changes will be posted on this page with an updated date.
                </p>
                <p className="terms-paragraph terms-highlight">
                  Continued use of the Service constitutes acceptance of the updated Terms.
                </p>
              </div>

              {/* Section 13 */}
              <div className="terms-section">
                <h2 className="terms-section-title">13. Governing Law</h2>
                <p className="terms-paragraph">
                  These Terms are governed by the laws applicable in the jurisdiction where Revexia 
                  operates, without regard to conflict of law principles.
                </p>
              </div>

              {/* Section 14 */}
              <div className="terms-section">
                <h2 className="terms-section-title">14. Contact Information</h2>
                <p className="terms-paragraph">
                  If you have questions about these Terms, contact:
                </p>
                <div className="terms-contact-box">
                  <p className="terms-contact-brand">Revexia</p>
                  <a
                    href="mailto:support@revexia.ai"
                    className="terms-contact-link"
                  >
                    📧 support@revexia.ai
                  </a>
                  <a
                    href="https://www.revexia.ai"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="terms-contact-link"
                  >
                    🌍 https://www.revexia.ai
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer - Exact same as HomePage */}
        <footer className="footer-v2" id="contact">
          <div className="container-footer-v2">
            {/* Footer Main Content */}
            <div className="footer-main-content">
              {/* Brand Section */}
              <div className="footer-brand-section-v2">
                <div className="footer-logo-wrapper">
                  <img src={Logo} alt="Revexia" className="footer-logo-image" />
                </div>
                <p className="footer-brand-description-v2">
                  A platform to turn social media DM engagement into automated revenue with AI-driven personalization.
                </p>
              </div>

              {/* Informations Column */}
              <div className="footer-column-v2">
                <h4 className="footer-column-heading-v2">Informations</h4>
                <ul className="footer-column-links-v2">
                  <li>
                    <a href="/">Home</a>
                  </li>
                  
                </ul>
              </div>

              {/* Social Column */}
              <div className="footer-column-v2">
                <h4 className="footer-column-heading-v2">Social</h4>
                <ul className="footer-column-links-v2">
                  <li>
                    <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                      Facebook
                    </a>
                  </li>
                  <li>
                    <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                      Instagram
                    </a>
                  </li>
                  <li>
                    <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                      Twitter
                    </a>
                  </li>
                  <li>
                    <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                      LinkedIn
                    </a>
                  </li>
                  <li>
                    <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer">
                      TikTok
                    </a>
                  </li>
                </ul>
              </div>

              {/* Help Column */}
              <div className="footer-column-v2">
                <h4 className="footer-column-heading-v2">Help</h4>
                <ul className="footer-column-links-v2">
                  <li>
                    <Link to="/contact">Contact</Link>
                  </li>
                  
                  <li>
                    <Link to="/terms">Terms & conditions</Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                  </li>
                   <li>
                                      <Link to="/facebook-terms">Facebook Terms</Link>
                                    </li>
                </ul>
              </div>
            </div>

            {/* Footer Divider */}
            <hr className="footer-divider-line-v2" />

            {/* Footer Bottom - License */}
            <div className="footer-bottom-v2">
              <p className="footer-copyright-v2">
                © 2026 Revexia. All rights reserved. Developed by{" "}
                <a
                  href="https://softwarebari.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="developer-link"
                >
                  Softwarebari
                </a>
                .
              </p>
              <div className="footer-legal-links-v2">
                <Link to="/privacy-policy">Privacy Policy</Link>
                <span className="separator-v2">|</span>
                <Link to="/terms">Terms &amp; Conditions</Link>
                <span className="separator-v2">|</span>
                <a href="/cookies">Cookies Policy</a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
}

export default TermsOfService;